export const DOMAIN = "https://baksotujuhpemuda.com";

export const BUSINESS = {
  name: "Bakso Tujuh Pemuda",
  tagline: "Bakso Hangat Andalan Keluarga Bogor",
  established: "Mei 2025",
  description:
    "Rumah makan bakso di Bogor Tengah dengan bakso urat jumbo, topping tetelan goreng renyah, mie yamin ala Bandung, dan dapur terbuka. Buka setiap hari 09.00–21.00 WIB.",
  address: {
    street: "Jl. Pengadilan No. 51",
    full: "Jl. Pengadilan No. 51, RT.05/RW.03, Pabaton, Kecamatan Bogor Tengah, Kota Bogor, Jawa Barat 16121",
    kelurahan: "Pabaton",
    kecamatan: "Bogor Tengah",
    city: "Kota Bogor",
    region: "Jawa Barat",
    postalCode: "16121",
    landmark: "Persis di seberang Sekolah Regina Pacis Bogor",
  },
  hoursLabel: "Setiap hari, 09.00–21.00 WIB",
  phoneDisplay: "+62 851-4350-5107",
  phoneIntl: "+6285143505107",
  links: {
    whatsapp:
      "https://wa.me/6285143505107?text=Halo%20Bakso%20Tujuh%20Pemuda%2C%20saya%20ingin%20reservasi%20atau%20bertanya.",
    orderOnline: "https://esb.co.id/BTPD/BTP/order?mode=delivery&id=3",
    instagram: "https://instagram.com/baksotujuhpemuda",
    tiktok: "https://tiktok.com/@baksotujuhpemuda",
    linktree: "https://linktr.ee/baksotujuhpemuda",
    maps: "https://maps.app.goo.gl/Q8kkCa6tv69aKWAw6",
    directions:
      "https://www.google.com/maps/dir/?api=1&destination=Bakso%20Tujuh%20Pemuda%2C%20Jl.%20Pengadilan%20No.51%2C%20Bogor",
    googleReview: "https://g.co/kgs/TTRJdF6",
    mapsEmbed:
      "https://maps.google.com/maps?q=Bakso%20Tujuh%20Pemuda%2C%20Jl.%20Pengadilan%20No.51%20Bogor&z=16&output=embed",
  },
  images: {
    hero: "https://images.unsplash.com/photo-1774370793603-3c00fd215bb8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwzfHxpbmRvbmVzaWFuJTIwYmFrc28lMjBtZWF0YmFsbCUyMHNvdXAlMjBmb29kJTIwYm93bHxlbnwwfHx8fDE3ODg4NTE1NTJ8MA&ixlib=rb-4.1.0&q=85&w=1400",
    baksoHalus: "https://images.unsplash.com/photo-1687419950105-b1cdeb6c66bc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwxfHxpbmRvbmVzaWFuJTIwYmFrc28lMjBtZWF0YmFsbCUyMHNvdXAlMjBmb29kJTIwYm93bHxlbnwwfHx8fDE3ODg4NTE1NTJ8MA&ixlib=rb-4.1.0&q=85&w=1000",
    mieYamin: "https://images.unsplash.com/photo-1701480253822-1842236c9a97?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwzfHxhc2lhbiUyMG5vb2RsZSUyMHNvdXAlMjBib3dsfGVufDB8fHx8MTc4ODg1MTU1Nnww&ixlib=rb-4.1.0&q=85&w=1000",
    esCampur: "https://images.unsplash.com/photo-1726796573992-cb5cd702cf1a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzV8MHwxfHNlYXJjaHwyfHxpbmRvbmVzaWFuJTIwZGVzc2VydCUyMGVzJTIwY2FtcHVyJTIwY2VuZG9sJTIwYmV2ZXJhZ2V8ZW58MHx8fHwxNzg4ODUxNTUyfDA&ixlib=rb-4.1.0&q=85&w=1000",
    interior: "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxjb3p5JTIwcmVzdGF1cmFudCUyMGRpbmluZyUyMGludGVyaW9yfGVufDB8fHx8MTc4ODg1MTU1Nnww&ixlib=rb-4.1.0&q=85&w=1400",
    openKitchen: "https://images.unsplash.com/photo-1583354608715-177553a4035e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwzfHxjb3p5JTIwcmVzdGF1cmFudCUyMGRpbmluZyUyMGludGVyaW9yfGVufDB8fHx8MTc4ODg1MTU1Nnww&ixlib=rb-4.1.0&q=85&w=1200",
  },
};

export const PRICE_NOTE =
  "Harga terakhir diverifikasi pada Desember 2025 dan dapat berubah sewaktu-waktu.";

export const MENU_CATEGORIES = [
  {
    id: "bakso",
    title: "Bakso",
    note: "Disajikan dengan tetelan goreng dan pilihan bihun atau kwetiau.",
    items: [
      { id: "bakso-halus", name: "Bakso Halus", price: "Rp 27.000", desc: "Bakso sapi bertekstur halus dan lembut dalam kuah kaldu sapi bening yang gurih." },
      { id: "bakso-urat-sedang", name: "Bakso Urat Sedang", price: "Rp 33.000", desc: "Bakso urat dengan cincangan urat yang terasa di setiap gigitan." },
      { id: "bakso-daging-sedang", name: "Bakso Daging Sedang", price: "Rp 33.000", desc: "Bakso daging sapi ukuran sedang, rasa dagingnya kuat." },
      { id: "bakso-urat-besar", name: "Bakso Urat Besar", price: "Rp 39.000", desc: "Primadona di sini: bakso urat jumbo yang empuk, garing, dan agak kenyal, ditemani dua bakso halus kecil.", favorite: true },
      { id: "bakso-daging-besar", name: "Bakso Daging Besar", price: "Rp 39.000", desc: "Bakso daging ukuran jumbo untuk yang ingin puas." },
      { id: "bakso-telur", name: "Bakso Telur", price: "Rp 39.000", desc: "Bakso besar berisi telur di dalamnya." },
    ],
  },
  {
    id: "mie",
    title: "Mie Yamin & Mie Ayam",
    note: "Mie yamin ala Bandung dan mie ayam ala Jawa Tengah, diracik fresh setelah dipesan.",
    items: [
      { id: "mie-yamin-pangsit", name: "Mie Yamin Pangsit", price: "Rp 28.000", desc: "Mie agak lebar dengan pilihan rasa manis (kecap legit) atau asin, topping ayam cincang royal dan pangsit rebus.", favorite: true },
      { id: "mie-yamin", name: "Mie Yamin", price: "mulai Rp 28.000", desc: "Yamin manis atau asin ala Bandung dengan ayam cincang berbumbu lada dan garam." },
      { id: "mie-ayam", name: "Mie Ayam ala Jawa Tengah", price: "mulai Rp 28.000", desc: "Berkuah gurih manis, lengkap dengan sawi hijau, ayam berbumbu kecap, dan pangsit goreng." },
    ],
  },
  {
    id: "pelengkap",
    title: "Pelengkap",
    note: "Teman menyeruput kuah hangat.",
    items: [
      { id: "bakso-goreng", name: "Bakso Goreng (isi 2)", price: "Rp 12.000", desc: "Kenyal dan empuk, disajikan hangat dengan cocolan saus sambal pedas manis." },
    ],
  },
  {
    id: "minuman",
    title: "Minuman & Pencuci Mulut",
    note: "Penyegar setelah sambal yang pedasnya kuat.",
    items: [
      { id: "es-campur", name: "Es Campur", price: "Rp 28.000", desc: "Alpukat, nangka, sagu mutiara, dan kelapa dengan rasa manis yang pas." },
      { id: "es-cendol", name: "Es Cendol", price: "Rp 18.000", desc: "Segar dan tidak terlalu manis, penutup yang ringan." },
    ],
  },
];

export const ALL_ITEMS = MENU_CATEGORIES.flatMap((c) =>
  c.items.map((i) => ({ ...i, category: c.id, categoryTitle: c.title }))
);

export const SIGNATURES = [
  { id: "bakso-urat-besar", name: "Bakso Urat Besar", price: "Rp 39.000", badge: "Paling Favorit", desc: "Bakso urat jumbo dengan tetelan goreng renyah di luar, gurih lumer di dalam.", image: BUSINESS.images.hero, alt: "Semangkuk bakso urat besar dengan kuah kaldu dan taburan seledri", w: 1400, h: 933 },
  { id: "bakso-halus", name: "Bakso Halus", price: "Rp 27.000", badge: "Klasik", desc: "Halus, lembut, dan menghangatkan — pintu masuk rasa Bakso Tujuh Pemuda.", image: BUSINESS.images.baksoHalus, alt: "Bakso halus dengan kuah kaldu bening dan bihun", w: 1000, h: 667 },
  { id: "mie-yamin-pangsit", name: "Mie Yamin Pangsit", price: "Rp 28.000", badge: "Ala Bandung", desc: "Manis legit atau asin gurih, dengan ayam cincang royal dan pangsit rebus.", image: BUSINESS.images.mieYamin, alt: "Mie yamin dengan topping ayam cincang dan pangsit", w: 1000, h: 667 },
  { id: "es-campur", name: "Es Campur", price: "Rp 28.000", badge: "Penutup Segar", desc: "Alpukat, nangka, sagu mutiara, dan kelapa — penawar pedas sambal kami.", image: BUSINESS.images.esCampur, alt: "Es campur dengan alpukat, nangka, dan sagu mutiara", w: 1000, h: 667 },
];

export const FAQS = [
  { q: "Di mana lokasi Bakso Tujuh Pemuda?", a: `Kami berada di ${BUSINESS.address.full} — persis di seberang Sekolah Regina Pacis Bogor. Lihat petunjuk arah di halaman Lokasi.` },
  { q: "Jam berapa Bakso Tujuh Pemuda buka?", a: `Kami buka ${BUSINESS.hoursLabel}.` },
  { q: "Menu apa saja yang tersedia dan berapa harganya?", a: "Ada enam varian bakso (Rp 27.000–Rp 39.000), mie yamin ala Bandung dan mie ayam ala Jawa Tengah (mulai Rp 28.000), bakso goreng (Rp 12.000), serta es campur dan es cendol. Rincian lengkap ada di halaman Menu." },
  { q: "Apakah Bakso Tujuh Pemuda halal?", a: "Ya. Seluruh menu kami telah bersertifikat halal, sebagaimana diumumkan melalui kanal resmi kami pada Desember 2025." },
  { q: "Apa yang membedakan bakso di sini?", a: "Topping tetelan goreng — renyah di luar, gurih lumer di dalam — yang menggantikan tetelan rebus biasa, plus dapur terbuka di mana setiap mangkuk diracik fresh setelah dipesan." },
  { q: "Bagaimana cara reservasi atau pesan online?", a: "Reservasi dan pertanyaan bisa melalui WhatsApp resmi kami, dan pesan antar tersedia lewat tautan Pesan Online di halaman Kontak." },
  { q: "Apakah tempatnya cocok untuk keluarga atau rombongan?", a: "Ya. Area makan kami luas dan nyaman, dengan area parkir yang memadai — cocok untuk keluarga maupun rombongan teman." },
];

export const NAV_LINKS = [
  { to: "/", label: "Beranda", testid: "nav-link-beranda" },
  { to: "/menu/", label: "Menu", testid: "nav-link-menu" },
  { to: "/tentang/", label: "Tentang", testid: "nav-link-tentang" },
  { to: "/lokasi/", label: "Lokasi", testid: "nav-link-lokasi" },
  { to: "/kontak/", label: "Kontak", testid: "nav-link-kontak" },
  { to: "/faq/", label: "FAQ", testid: "nav-link-faq" },
];

export const restaurantLd = {
  "@context": "https://schema.org",
  "@type": "Restaurant",
  "@id": `${DOMAIN}/#restaurant`,
  name: BUSINESS.name,
  url: `${DOMAIN}/`,
  image: [BUSINESS.images.hero],
  description: BUSINESS.description,
  telephone: BUSINESS.phoneIntl,
  servesCuisine: ["Bakso", "Masakan Indonesia"],
  priceRange: "Rp12.000–Rp39.000",
  address: {
    "@type": "PostalAddress",
    streetAddress: "Jl. Pengadilan No. 51, RT.05/RW.03, Pabaton",
    addressLocality: "Kota Bogor",
    addressRegion: "Jawa Barat",
    postalCode: "16121",
    addressCountry: "ID",
  },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"],
      opens: "09:00",
      closes: "21:00",
    },
  ],
  sameAs: [BUSINESS.links.instagram, BUSINESS.links.tiktok, BUSINESS.links.linktree, BUSINESS.links.maps],
  hasMenu: `${DOMAIN}/menu/`,
};

export const websiteLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${DOMAIN}/#website`,
  name: BUSINESS.name,
  url: `${DOMAIN}/`,
  inLanguage: "id",
  publisher: { "@id": `${DOMAIN}/#restaurant` },
};

export const breadcrumbLd = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${DOMAIN}${it.path}`,
  })),
});
